import { render, staticRenderFns } from "./SystemAlert.vue?vue&type=template&id=0619bd35"
import script from "./SystemAlert.vue?vue&type=script&lang=js"
export * from "./SystemAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports